import { render, staticRenderFns } from "./Ozempic.vue?vue&type=template&id=14eba4ee&scoped=true&"
import script from "./Ozempic.vue?vue&type=script&lang=js&"
export * from "./Ozempic.vue?vue&type=script&lang=js&"
import style0 from "./Ozempic.vue?vue&type=style&index=0&id=14eba4ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14eba4ee",
  null
  
)

export default component.exports